import { useTranslation } from 'react-i18next';
import { mdiTablePivot, mdiViewList, mdiViewModule } from '@mdi/js';

import {
    ButtonToggle,
    IButtonToggleProps,
} from 'common/components/ButtonToggle';

export enum EView {
    Grid = 'grid',
    List = 'list',
    Matrix = 'matrix',
}

const BUTTONS = {
    [EView.Grid]: {
        key: EView.Grid,
        icon: mdiViewModule,
        ariaLabel: 'gridView',
    },
    [EView.List]: {
        key: EView.List,
        icon: mdiViewList,
        ariaLabel: 'listView',
    },
    [EView.Matrix]: {
        key: EView.Matrix,
        icon: mdiTablePivot,
        ariaLabel: 'matrixView',
    },
};

interface IProps extends Omit<IButtonToggleProps<EView>, 'buttons'> {
    buttons?: EView[];
}

export const ViewToggle = ({ buttons, ...other }: IProps) => {
    const [translate] = useTranslation();

    const buttonList = buttons || [EView.Grid, EView.List];

    const viewButtons = buttonList.map((button) => {
        const buttonData = BUTTONS[button];

        return {
            ...buttonData,
            ariaLabel: translate(buttonData.ariaLabel),
        };
    });

    return <ButtonToggle buttons={viewButtons} {...other} />;
};
